import { decorate, extendObservable, computed } from "mobx";
import Core from "Core";
import moment from "moment";

export class Log extends Core.Stores.Model {
  constructor(store, id) {
    super(store, id);

    extendObservable(this, {
      Date: null,
      ApplicationId: null,
      ApplicationVersion: null,
      Domain: null,
      UsedLogin: null,
      SessionId: null,
      IpAddress: null,
      Success: null,
      Message: null
    });
  }

  get asJSON() {
    return {
      Id: this.Id,
      Date: this.Date instanceof moment ? this.Date.format() : null,
      ApplicationId: this.ApplicationId,
      ApplicationVersion: this.ApplicationVersion,
      Domain: this.Domain,
      UsedLogin: this.UsedLogin,
      SessionId: this.SessionId,
      IpAddress: this.IpAddress,
      Success: this.Success,
      Message: this.Message
    };
  }

  parseAsDate(key) {
    return key === "Date";
  }
}

decorate(Log, {
  asJSON: computed
});



// WEBPACK FOOTER //
// ./src/Stores/DataStore/Models/Log.js